import { JsonObject, JsonProperty } from 'json2typescript';
import { ApiResultsResponse } from '../../api/responses/api-results-response.model';
import { SlotReward } from '../slot-reward.model';

@JsonObject('SlotRewardsResultsResponse')
export class SlotRewardsResultsResponse extends ApiResultsResponse<SlotReward> {

  @JsonProperty('results', [SlotReward])
  override results: SlotReward[] = [];
}
